import { z } from 'zod';
import {
  NICKNAME_MAX_LENGTH,
  NICKNAME_MIN_LENGTH,
  ROOM_CODE_ALPHABET,
  ROOM_CODE_LENGTH,
  type FieldSize,
} from './constants';

/** Normalise un pseudo : Unicode NFKC, espaces superflus retirés. */
export function normalizeNickname(raw: string): string {
  return raw.normalize('NFKC').trim().replace(/\s+/g, ' ');
}

const NICKNAME_PATTERN = /^[\p{L}\p{N} _.-]+$/u;

export const nicknameSchema = z
  .string()
  .max(64)
  .transform(normalizeNickname)
  .pipe(z.string().min(NICKNAME_MIN_LENGTH).max(NICKNAME_MAX_LENGTH).regex(NICKNAME_PATTERN));

export const roomCodeSchema = z
  .string()
  .max(16)
  .transform((value) => value.trim().toUpperCase())
  .pipe(z.string().regex(new RegExp(`^[${ROOM_CODE_ALPHABET}]{${ROOM_CODE_LENGTH}}$`)));

// Doit rester aligné sur FIELD_SIZES : le type inféré est vérifié par `satisfies`.
const fieldSizeSchema = z.union([
  z.literal(8),
  z.literal(16),
  z.literal(32),
  z.literal(64),
  z.literal(128),
]) satisfies z.ZodType<FieldSize>;

export const settingsSchema = z.object({
  fieldSize: fieldSizeSchema,
  botDifficulty: z.enum(['easy', 'normal', 'hard']),
});

export const partialSettingsSchema = settingsSchema.partial();

export const createRoomSchema = z.object({
  nickname: nicknameSchema,
  settings: partialSettingsSchema.optional(),
});

export const joinRoomSchema = z.object({
  code: roomCodeSchema,
  nickname: nicknameSchema,
});

export const resumeRoomSchema = z.object({
  code: roomCodeSchema,
  sessionToken: z.string().min(8).max(64),
});

export const kickSchema = z.object({ playerId: z.string().min(1).max(64) });

export const inputSchema = z.object({
  key: z.enum(['left', 'right']),
  action: z.enum(['down', 'up']),
  t: z.number().finite(),
});

export const watchSchema = z.object({ heatId: z.string().regex(/^r\d{1,2}-h\d{1,3}$/) });
